import PageHead from '@/components/PageHead';
import PageLayout from '@/components/layout/page-layout';
import Container from '@/components/Container';
import HeadingOne from '@/components/Heading/HeadingOne';
import NextImage from 'next/image';
import NextLink from 'next/link';
import { SocialActionCard } from '@/components/SocialActionCard';
import { FiExternalLink } from 'react-icons/fi';
import SocialActionLink from '@/components/SocialActionLink';

export default function Page() {
	return (
		<>
			<PageHead
				page={{
					title: 'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					keywords:
						'OSC, Instituto, Deixe Vivo, Doação de órgãos e tecidos, transplantes, renal, tecidos, história, trajetória',
					colorScheme: 'light dark',
					description: 'Instituto Deixe Vivo',
					robots: 'follow, index',
				}}
				og={{
					description:
						'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					site_name:
						'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					title: 'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					type: 'website',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						fbAdmins: 'instituto.deixevivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
						type: 'image/jpg',
						width: '1200',
						height: '1200',
					},
				}}
				twitter={{
					card: 'summary',
					description:
						'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					site: 'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					title: 'Instituto Deixe Vivo | Educar para doar: doação de órgãos',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
					},
				}}
			/>
			<PageLayout>
				<Container className="py-8">
					<div className="relative">
						<HeadingOne horizontalRow>
							Educar para Doar: doação de órgãos
						</HeadingOne>
						<NextImage
							className="float-right mt-4"
							width={192}
							height={192}
							src="https://res.cloudinary.com/oliveiradev/image/upload/v1688396073/InstitutoDeixeVivo/logos/logo-educar-para-doar.png"
							alt="Educar para Doar: doação de órgãos"
						/>
					</div>

					<section className="mt-4">
						<p tabIndex={0}>
							Acreditamos que a real mudança na cultura da doação de órgãos no
							Brasil, vem a partir da educação. O Instituto está sempre criando
							projetos e pensando em ações e campanhas que incentivem as pessoas
							a se tornarem doadoras de órgãos. Mais de 59 mil pessoas* estão à
							espera por um transplante no país enquanto um dos principais
							motivos da recusa das famílias para não autorizarem a doação de
							órgãos, é a falta de informação e conhecimento sobre o tema.
							Considerando este cenário, precisamos realmente educar e
							desmistificar as questões que envolvem esse contexto. Mostrar cada
							vez mais o quanto cada SIM para a doação de órgãos pode salvar
							milhares de vidas.
						</p>

						<p tabIndex={0}>
							Nesta frente, os projetos do Instituto levam educação em doação de
							órgãos nas escolas,universidades, empresas, organizações, em
							qualquer lugar com pessoas dispostas a conhecerem mais sobre o
							tema e ajudarem a salvar vidas!
						</p>

						<ul
							role="list"
							className="mt-8 w-full flex flex-wrap justify-center py-8 gap-20 xl:gap-0 xl:justify-evenly items-center"
						>
							<li tabIndex={0}>
								<SocialActionCard
									context="Evento Online e Presencial"
									title='"Eu sou doador(a) de órgãos, e você?"'
									description="Palestra dinâmica e
									descontraída com a ideia de falar sobre a importância da
									doação de órgãos de uma forma leve porém educativa."
									Link={
										<SocialActionLink>
											<NextLink
												className="flex justify-center w-full h-full cursor-pointer p-3 "
												target="_blank"
												href="mailto:contato@deixevivo.org.br"
											>
												<span>Saiba mais!</span>
												<FiExternalLink className="ml-1" />
											</NextLink>
										</SocialActionLink>
									}
								/>
							</li>

							<li tabIndex={0}>
								<SocialActionCard
									context="Evento Online e Presencial"
									title="Oficina de Escutatória"
									description="Histórias sobre doação na qual conectamos
									pessoas de diferentes contextos da doação de órgãos onde cada
									uma contará sua história e como a doação de órgãos mudou ou
									pode mudar a sua realidade - esta ação sempre acontece em
									parceria com a Escola de Empatia que é mediadora do evento."
									Link={
										<SocialActionLink>
											<NextLink
												className="flex justify-center w-full h-full cursor-pointer p-3 "
												target="_blank"
												href="mailto:eventos@deixevivo.org.br"
											>
												<span>Saiba mais!</span>
												<FiExternalLink className="ml-1" />
											</NextLink>
										</SocialActionLink>
									}
								/>
							</li>

							<li tabIndex={0}>
								<SocialActionCard
									context="Comunicação"
									title="Materiais educativos"
									description={
										<>
											Produzimos cartilhas e materiais para serem usados na hora
											de educar sobre doação de órgãos. Crianças, Jovens,
											Adultos, independente da idade, criamos materiais
											exclusivos de acordo com a necessidade e contexto.
											{/* <NextLink className='text-sm text-sky-500 flex justify-center mt-2' href="#">
												Conheça nossas cartilhas
												<span><FiExternalLink className="ml-1" /></span>
											</NextLink> */}
										</>
									}
									Link={
										<SocialActionLink>
											<span className="flex justify-center w-full h-full cursor-pointer p-3 ">
												<span>Em breve!</span>
											</span>
										</SocialActionLink>
									}
								/>
							</li>
						</ul>
					</section>

					<section className="mt-8 flex flex-col lg:flex-row items-center">
						<NextImage
							className=""
							width={192}
							height={192}
							src="https://res.cloudinary.com/oliveiradev/image/upload/v1688396073/InstitutoDeixeVivo/logos/logo-setembro-verde.png"
							alt="Educar para Doar: doação de órgãos"
						/>
						<div>
							<h2 className="font-bold" tabIndex={0}>
								Data Especial
							</h2>
							<p tabIndex={0}>
								#setembroverde - Dia 27 de Setembro é comemorado o Dia Nacional
								da Doação de Órgãos. O Instituto Deixe Vivo sempre traz uma
								série de ações, campanhas, eventos e conteúdos especiais para a
								data, tanto no formato online quanto presencial. Sempre buscamos
								parceiros e apoiadores para nossa campanha.
							</p>
						</div>
					</section>
				</Container>
			</PageLayout>
		</>
	);
}
